import React from "react";
import "./Footer.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useLocalContext } from "../../context/LocalContext";
import {
  resolveSiteEmail,
  resolveSiteName,
  resolveSitePhone,
  SITE_DOMAIN,
} from "../../utils/siteConfig";

const Footer = () => {
  const { webinfo = {} } = useLocalContext();
  const navigate = useNavigate();
  const year = new Date().getFullYear();
  const email = resolveSiteEmail(webinfo);
  const phoneText = resolveSitePhone(webinfo);
  const phoneCall = String(webinfo?.phonecall || webinfo?.phone || "").trim();
  const siteName = resolveSiteName(webinfo);

  return (
    <footer className="ftr" aria-label="Footer">
      <div className="ftr__wrap">
        <motion.div
          className="ftr__cta"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div>
            <h3 className="ftr__ctaTitle">Device not cooperating?</h3>
            <p className="ftr__ctaText">
              Start a guided setup or reach Smart Setup Solutions — we’ll help you finish.
            </p>
          </div>
          <div className="ftr__ctaBtns">
            <button type="button" className="ftr__btn ftr__btn--primary" onClick={() => navigate("/contact")}>
              Get help
            </button>
            <a className="ftr__btn ftr__btn--ghost" href="/printlab">
              Printer setup
            </a>
          </div>
        </motion.div>

        <div className="ftr__grid">
          <div>
            <h2 className="ftr__brandName">{siteName}</h2>
            <p className="ftr__brandText">
              Guided printer and Wi‑Fi extender setup with live specialist support —
              for homes and small offices.
            </p>
            <div className="ftr__meta">
              <p>
                <a href={`mailto:${email}`}>{email}</a>
              </p>
              {phoneText && (
                <p>
                  <a href={phoneCall ? `tel:${phoneCall}` : "#"}>{phoneText}</a>
                </p>
              )}
              <p className="ftr__domain">{SITE_DOMAIN}</p>
            </div>
          </div>

          <div>
            <h4 className="ftr__h4">Setup</h4>
            <ul className="ftr__links">
              <li><a href="/printlab">Printer help</a></li>
              <li><a href="/wavelab">Extender help</a></li>
              <li><a href="/services">All services</a></li>
            </ul>
          </div>

          <div>
            <h4 className="ftr__h4">Company</h4>
            <ul className="ftr__links">
              <li><a href="/about">About</a></li>
              <li><a href="/process">How it works</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="ftr__h4">Legal</h4>
            <ul className="ftr__links">
              <li><a href="/Terms-and-condition">Terms</a></li>
              <li><a href="/privacy-policy">Privacy</a></li>
              <li><a href="/disclaimer">Disclaimer</a></li>
            </ul>
          </div>
        </div>

        <div className="ftr__bottom">
          <p className="ftr__copy">
            © {year} {siteName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
